import { countries, downloadBanners } from "@/constants/footerConstants";

import { FooterLink, RightFooterData } from "@/components/common/Footer/types";

export const prepareLeftFooterData = (arr: FooterLink[]) => {
  return arr.map((item) => cleanObject(item));
};

const cleanObject = (obj: FooterLink) => {
  if (!obj || typeof obj !== "object") {
    return obj;
  }

  const cleaned: FooterLink = {} as FooterLink;

  if (obj.name) {
    cleaned.name = obj.name;
  }

  if (obj.link_rewrite) {
    cleaned.link_rewrite = obj.link_rewrite;
  }

  if (obj.children) {
    cleaned.children = prepareLeftFooterData(obj.children);
  }

  return cleaned;
};

export const prepareRightFooterData = (
  footerData: FooterLink[],
  host: string,
) => {
  const rightFooterData: RightFooterData = {} as RightFooterData;
  // Find legal array
  const legalData = footerData.find((d) => d.name === "Legal");

  const legal = [];
  if (legalData && legalData.children) {
    for (const item of legalData.children) {
      legal.push({
        name: item.name,
        link_rewrite: item.link_rewrite,
      });
    }
  }
  rightFooterData.legal = legal;

  // Find stay_connected array
  const stayConnectedData = footerData.find((d) => d.name === "Stay Connected");

  const stayConnected: FooterLink[] = [];
  if (stayConnectedData && stayConnectedData.children) {
    for (const item of stayConnectedData.children) {
      stayConnected.push({
        name: item.name,
        link_rewrite: item.link_rewrite,
      });
    }
  }
  rightFooterData.stay_connected = stayConnected;

  // Find contact info
  const contactData = footerData.find((d) => d.name === "Contact Info");

  const contactInfo: FooterLink[] = [];
  if (contactData && contactData.children) {
    for (const item of contactData.children) {
      contactInfo.push({
        name: item.name,
        link_rewrite: item.link_rewrite,
      });
    }
  }
  rightFooterData.contact_info = contactInfo;

  // Find mail
  const mailData = footerData.find((d) => d.name === "mail");

  const mail: FooterLink[] = [];
  if (mailData && mailData.children) {
    for (const item of mailData.children) {
      mail.push({
        name: item.name,
        link_rewrite: item.link_rewrite,
      });
    }
  }
  rightFooterData.mail = mail;

  rightFooterData.country_list = countries;

  rightFooterData.downloadApp = downloadBanners(host);

  return rightFooterData;
};
